import React, { useRef } from 'react';
import { Button } from 'antd';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CardSlider = ({ 
  children, 
  title = '',
  subtitle = '',
  icon: Icon = null,
  cardsToShow = 4
}) => {
  const sliderRef = useRef(null);
  
  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -280, behavior: 'smooth' });
    }
  };
  
  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 280, behavior: 'smooth' });
    }
  };

  // Filter out null children (cards that don't have data)
  const filteredChildren = React.Children.toArray(children).filter(child => child !== null);
  
  if (filteredChildren.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          {Icon && <Icon className="mr-2 h-5 w-5 text-golden-navy" />}
          <div>
            <h2 className="text-xl font-bold text-golden-navy">{title}</h2>
            {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
          </div>
        </div>
        
        <div className="flex space-x-2">
          <Button
            onClick={scrollLeft}
            icon={<ChevronLeft size={16} />}
            className="flex items-center justify-center"
            shape="circle"
          />
          <Button
            onClick={scrollRight}
            icon={<ChevronRight size={16} />}
            className="flex items-center justify-center"
            shape="circle"
          />
        </div>
      </div>
      
      <div 
        ref={sliderRef}
        className="flex overflow-x-auto pb-4 space-x-4 scrollbar-hide"
        style={{ 
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {filteredChildren.map((child, index) => (
          <div 
            key={index} 
            className="flex-none" 
            style={{ width: `calc(${100 / cardsToShow}% - ${(cardsToShow - 1) * 16 / cardsToShow}px)` }}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

// Add custom CSS to hide scrollbar
const style = document.createElement('style');
style.textContent = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`;
document.head.appendChild(style);

export default CardSlider;